import { FaStar, FaStarHalf } from "react-icons/fa6";

export function Rating({ rate }: { rate: number }) {
  const count = Math.trunc(rate);
  const half = rate - count;
  return (
    <ul className="flex flex-row">
      {Array(count)
        .fill(0)
        .map((_, i) => (
          <li>
            <FaStar color="#FFD700" size={16} />
          </li>
        ))}
      {half > 0 && (
        <li>
          <FaStarHalf color="#FFD700" size={16} />
        </li>
      )}
    </ul>
  );
}
export function formatCurrency(
  amount: number,
  currency: string = "USD",
  locale: string = "en-US"
): string {
  const formatter = new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
  });

  return formatter.format(amount);
}
